import React, { useEffect, useState } from "react";
import styles from "./AllProjectsItem.module.scss";
import { uniqueId } from "lodash";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import {
  setPostulationProject,
  setPostulationProjectId,
  getProjectQuestions,
  openNDAModal,
  closeNDAModal,
  setResponsiveFall,
  goToProjectId,
  getPostulationProjectStatus,
  ShowNotAbleModal,
} from "../../../store/actions/index";
import {
  openMainModal,
  getPostulations,
  getSubProjectBudgets,
  clearSubProjectBudgets,
  setPrivateCardIsOpen,
} from "../../../store/actions/profileActions";
import { withRouter } from "react-router-dom";
import { ReactComponent as SendIcon } from "../../../assets/svg/solicitudEnviada.svg";
import { ReactComponent as Send} from "../../../assets/svg/quieroPostularme.svg";
import SubProjectsNew from "../SubProjects/SubProjectsNew";
import { fireAnalytics } from "../../../utils/firebase";
import moment from "moment";
import defaultImage from "../../../assets/images/foto-bienvenida.jpg";
import ButtonPostulation from "../../ButtonPostulation/ButtonPostulation";
import ButtonSeeProject from "../../ButtonSeeProject/ButtonSeeProject";
import usePremiumCheck from "../../../hooks/usePremiumCheck";
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import ResponsiveFall from "../../UI/ResponsiveFall/ResponsiveFall";


const AllProjectsItem = ({
  dashboardView,
  onFocusRef,
  refProjectId,
  typeViewer,
  isSettingPostulation,
  clearSubProjectBudgets,
  item,
  showSubprojects = false,
  quotation,
  userId,
  setPrivateCardIsOpen,
  getPostulationProjectStatus,
  postulaciones,
  openNDAModal,
  closeNDAModal,
  getSubProjectBudgets,
  setPostulationProject,
  setPostulationProjectId,
  getProjectQuestions,
  subProjectBudgetsToSend,
  profileVisualizer,
  projectsOnPage,
  getPostulations,
  privateCardIsOpen,
  userData,
  ...props
}) => {

  const [moreInfo, setMoreInfo] = useState(true);
  const [preparePostulation, setPreparePostulation] = useState(false);
  const [isPostulating, setIsPostulating] = useState(true);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [showLightbox, setShowLightbox] = useState(false);
  const [budgetCount, setBudgetCount] = useState(0);
  const [imageUrls, setImageUrls] = useState([]);
  const [filteredProjectsStatus, setFilteredProjectsStatus] = useState([]);
  const history = useHistory();
  const userProject = props.profileVisualizer;
  const premiumCheck = usePremiumCheck();
  let {
    description,
    link,
    name,
    startDate,
    endDate,
    zone,
    id,
    sendDate,
    user,
    usuarioLikes,
  } = item;

 
  //Definimos ruta para redirigir al usuario
  const userFullName = userData.type === "COMPANY" ?  userData.razon_social : `${userData.name} ${userData.last_name}`;
  const route = `/comunidad-edify/${userData.id}/${userFullName}`;

  //Definimos de donde tomamos las fotos
  let imagenes = null;

  if (item?.proyecto_images) {
    if (Array.isArray(item?.proyecto_images) && item.proyecto_images.length > 0) {
      imagenes = item.proyecto_images.map((img, index) => (
        <div key={img.id} className={styles.customImg_container} onClick={() => handleOpenLightbox(index)}>
          <img src={img.image} alt="" className={`${styles.customImg} ${preparePostulation ? styles.whenOpen : ""}`} />
        </div>
      ));
    } else if (item?.image) {
      imagenes = (
        <div className={styles.customImg_container} >
          <img src={item.image} alt="" className={styles.customImg} />
        </div>
      );
    } else {
      imagenes = (
        <div className={styles.customImg_container}>
          <img src={defaultImage} alt="" className={`${styles.customImg} ${preparePostulation ? styles.whenOpen : ""}`} />
        </div>
      );
    }
  } else if (item?.image) {
    imagenes = (
      <div className={styles.customImg_container}>
        <img src={item.image} alt="" className={`${styles.customImg} ${preparePostulation ? styles.whenOpen : ""}`} />
      </div>
    );
  } else {
    imagenes = (
      <div className={styles.customImg_container}>
        <img src={defaultImage} alt="" className={`${styles.customImg} ${preparePostulation ? styles.whenOpen : ""}`} />
      </div>
    );
  }

  // Lee el contenido de los archivos y genera las URLs de imagen
  useEffect(() => {
    if (item?.proyecto_images) {
      if (Array.isArray(item?.proyecto_images) && item.proyecto_images.length > 0) {
        const urls = item.proyecto_images.map((img) => img.image);
        setImageUrls(urls);
      } else if (item?.image) {
        setImageUrls([item.image]);
      }
    } else if (item?.image) {
      setImageUrls([item.image]);
    } else {
      setImageUrls([defaultImage]);
    }
  }, [item]);
  const handleOpenLightbox = (index) => {
    setCurrentImageIndex(index);
    setShowLightbox(true);
  };

  const handleCloseLightbox = () => {
    setShowLightbox(false);
  };

  useEffect(() => {
    getPostulations(userData.id);
    getPostulationProjectStatus(item.id);
  }, []);


  moment.locale("es");
  endDate = props.isPostulation ? sendDate : endDate;
  const formatDate = (date) => {
    if (date !== null) {
      const formattedStartDate = moment(date).format("DD/MM/YYYY");
      return formattedStartDate;
    } else {
      return date;
    }
  };

  const capitalizeFirstLetter = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  // Formatear los campos
  const formattedName = capitalizeFirstLetter(name);
  const formattedDescription = capitalizeFirstLetter(description);


  let isProvider =
    props.meSession.id === user?.id || props.typeViewer === "misProyectos";
  const textButton = preparePostulation ? "Ver menos" : "Ver más";

  const handleRigthText = () => {
    /* const cardId = item.id;
    setPrivateCardIsOpen(!privateCardIsOpen.isOpen, cardId)
    setPreparePostulation(!preparePostulation);*/
    clearSubProjectBudgets(); 
    history.push(`/proyectosprivados/${item.id}`)
  };

  //Maneja el toggle de las card para que solo 1 sea visible
  useEffect(() => {
    if (privateCardIsOpen.isOpen && privateCardIsOpen.cardId === item.id) {
      setPreparePostulation(true);
    } else if (privateCardIsOpen.cardId !== item.id) {
      setPreparePostulation(false);
    }
  }, [privateCardIsOpen]);
  let { status } = postulaciones;


  useEffect(() => {
    filterAndSetProjects();
  }, [postulaciones]);

  // Función para filtrar y setear los proyectos
  const filterAndSetProjects = () => {
    const filteredProjects = projectsOnPage.map(project => {
      const matchingPostulacion = postulaciones.find(postulacion => postulacion.proyecto.id === project.id);
      if (matchingPostulacion) {
        return { ...project, status: matchingPostulacion.status };
      }
      return project;
    });
    setFilteredProjectsStatus(filteredProjects);
  };

const handleRedirectToUser = () => {
  const userName = user?.type === "COMPANY" ? user?.razon_social : `${user?.name} ${user?.last_name}`;
  const userId = user?.id;
  history.push(`comunidad-edify/${userId}/${userName}`);
};
  /* const handlePostulation = () => {
    if (!isSettingPostulation) {
      if (!status) {
        setPostulationProject(history, item, isProvider);
        fireAnalytics("apply_project", { category: "dashboard" });
        item && item.id && setPostulationProjectId(item.id);
        openNDAModal(true);
      } else {
        if (status === "SEND") return;
        if (isProvider) {
          setPostulationProject(item);
          history.push(route);
        } else if (preparePostulation) {
          history.push("/solicitudes");
        }
        fireAnalytics("dsh_open_project", { category: "publishing" });
        setPreparePostulation(!preparePostulation);
      }
    }
  }; */

  //Manejan los estados de los botones de las postulaciones
  const isPostulationSent = postulaciones.find(postulacion => postulacion.proyecto.id === item.id && postulacion.status === "SEND");
  const isPostulationAllowed = postulaciones.find(postulacion => postulacion.proyecto.id === item.id && postulacion.status === "ALLOWED");
  const isPostulationDenied = postulaciones.find(postulacion => postulacion.proyecto.id === item.id && postulacion.status === "NEGATED");
  const isPostulationNotSent = !isPostulationSent && !isPostulationAllowed && !isPostulationDenied;
  const showPostulationButton = userData.id !== item.user.id;

  return (
    <div className={styles.AllProjectsItemContainer}>
      <ul className={styles.AllProjectsItemList}>
        <li className={`${styles.AllProjectsItemList_listItem} ${styles.column1}`}>
          <Carousel
            showThumbs={false}
            className={styles.AllProjectsItemList_carousel}
            selectedItem={currentImageIndex}
            onChange={(index) => setCurrentImageIndex(index)}
            useKeyboardArrows={true}
            showIndicators={false}
            showStatus={false}
          >
            {imagenes}
          </Carousel>
        </li>
        <li className={`${styles.AllProjectsItemList_listItem} ${styles.column2}`}>{formattedName}</li>
        <li className={`${styles.AllProjectsItemList_listItem} ${styles.column3}`}>
          <div className={styles.subprojectContainer_titles}>
            {Array.isArray(item?.subproyecto) &&
              item?.subproyecto.map((subproject, index) => {
                return (
                  <div className={styles.subprojectContainer_titles_item} key={index}>
                    <p className={styles.subprojectContainer_titles_item_p}>{subproject.name}</p>
                  </div>
                );
              })}
          </div>
        </li>
        <li className={`${styles.AllProjectsItemList_listItem} ${styles.column4}`}>
          <p className={styles.dateAndZone_dates_p}>
            {formatDate(startDate)}
          </p>
        </li>
        <li className={`${styles.AllProjectsItemList_listItem} ${styles.column5}`}>
          <p className={styles.dateAndZone_dates_p}>
            {formatDate(endDate)}
          </p>
        </li>
        <li className={`${styles.AllProjectsItemList_listItem} ${styles.column6}`}>{zone}</li>
        <li className={`${styles.AllProjectsItemList_listItem} ${styles.column7}`}>
          {/* <div className={styles.AllProjectsItemList_listItem_postulationButton}>
            {filteredProjectsStatus?.map((project, index) => {
              return (
                <div key={index}>
                  {showPostulationButton && !project.status && project.id === item.id ? (
                    <ButtonPostulation
                      itemButtonText="Cotizar"
                      className={styles.viewProyect}
                      onClick={premiumCheck(handlePostulation)}
                      key={index}
                    />
                  ) : null}
                </div>
              );
            })}
          </div>
          <div className={styles.flex}>
            {isPostulationSent && (
              <div className={styles.solicitudEnviada}>
                <p className={styles.solicitudEnviada_p}>Solicitud Enviada</p>
                <Send width={10} height={10}/>              
              </div>
            )}
            {isPostulationAllowed && (
              <div className={styles.solicitudAprobada}>
                <p className={styles.solicitudAprobada_p}>Solicitud Aprobada</p>
                <Send width={10} height={10}/>
              </div>
            )}
            {isPostulationDenied && (
              <div className={styles.solicitudRechazada}>
                <p className={styles.solicitudRechazada_p}>Solicitud Rechazada</p>
              </div>
            )}*/}
            <div className={styles.flex_buttonSeeMore}>
              <ButtonSeeProject
                link={link}
                onClick={premiumCheck(handleRigthText)}
                rigthText={textButton}
                preparePostulation={preparePostulation}
                moreInfo={moreInfo}
                className={styles.viewProyect}
                key={item.id}
              />
            </div>
         {/*  </div> */}
        </li> 
        <li className={`${styles.AllProjectsItemList_listItem} ${styles.column8}`}>
          <div className={styles.AllProjectsItemList_listItem_userData} onClick={() => handleRedirectToUser()}>
            <img src={user?.image_profile} alt="Foto de perfil" className={styles.AllProjectsItemList_listItem_userData_img} />
          {user?.type === "COMPANY" ? user?.razon_social : `${user?.name} ${user?.last_name}`}
          </div>
        </li>
      </ul>
      {/* {usuario && preparePostulation && privateCardIsOpen.cardId === item.id ? (
        <div className={styles.subprojectContainer}>
          <div className={styles.subprojectContainer_userAndDescription}>
            <div className={styles.subprojectContainer_user}>
              <h4 className={styles.subprojectContainer_user_title}>Usuario</h4>
              <ProjectProfileData
                onClick={() => setMoreInfo(false)}
                userProject={userProject}
                usuarioImage={user.image_profile}
                usuario={usuario}
                usuarioLikes={usuarioLikes}
                userId={user.id}
                item={item}
                key={uniqueId()}
              />
            </div>
            <div className={styles.subprojectContainer_description}>
              <h4 className={styles.subprojectContainer_descriptionTitle}>Descripción general</h4>
              <p className={styles.subprojectContainer_descriptionTitle_txt}>{formattedDescription}</p>
            </div>
          </div>
          <div className={styles.subprojectContainer_rubros}>
            <h4 className={styles.subprojectContainer_rubros_title}>Detalles</h4>
            <SubProjectsNew
              item={item}
              opened={!preparePostulation ? false : true}
              isPostulating={isPostulating}
              allowOpen={preparePostulation}
              onClick={handlePostulation}
              dashboardView={dashboardView}
              itemButtonText="ir al proyecto"
              key={item.id}
              isPostulationAllowed={isPostulationAllowed}
              subProjectBudgetsToSend={subProjectBudgetsToSend}
            />
          </div>
        </div>
      ) : null
      } */}
      {
        showLightbox && (
          <div className={styles.lightbox}>
            <div className={styles.lightbox_container}>
              <span className={styles.close_btn} onClick={handleCloseLightbox}>X</span>
              <img src={imageUrls[currentImageIndex]} alt="Full-size" />
            </div>
          </div>
        )
      }
    </div >
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    dashboardView: ownProps.dashboardView || false,
    item: ownProps.item,
    isSettingPostulation: state.dashboard.isSettingPostulation,
    meSession: state.general.meSession,
    profileVisualizer: state.general.profileVisualizer,
    questions: state.profile.questions,
    postulaciones: state.profile.postulations,
    projectsOnPage: state.dashboard.allProjects.entities || state.dashboard.allProjects,
    userData: state.general.userData,
    subProjectBudgetsToSend: state.profile.subProjectBudgets,
    privateCardIsOpen: state.profile.privateCardIsOpen,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    getProjectQuestions,
    setPostulationProject,
    setPostulationProjectId,
    openMainModal,
    openNDAModal,
    closeNDAModal,
    goToProjectId,
    clearSubProjectBudgets,
    setResponsiveFall,
    setPrivateCardIsOpen,
    ShowNotAbleModal,
    getPostulations,
    getSubProjectBudgets,
    getPostulationProjectStatus,
  })(AllProjectsItem)
);
